/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import utils from "../../utils/utils";

class PipelineTextarea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    const textarea = document.querySelector('.pipeline-textarea');
    if (textarea) {
      const childNodes = textarea.getElementsByTagName('*');
      const childNodesArr = Array.prototype.slice.call(childNodes);
      const allTagA = childNodesArr.filter(item => item.tagName === 'A');
      allTagA.forEach(item => {
        item.onclick = (event) => {
          event.preventDefault();
          if (item.href) {
            if (utils.isShihuo()) {
              if (item.href.indexOf('sh-gateway.shihuo.cn') >= 0) {
                window.Jockey.send('action', {
                  url: `shihuo://www.shihuo.cn?route=fastWebview&url=${encodeURIComponent(item.href)}`
                })
              } else {
                utils.jumpToUrl(this.props.routeParams, item.href, item.href, {}, -1, this.props, false, {}, {}, false);
              }
            } else {
              utils.jumpToUrl(this.props.routeParams, item.href, item.href, {}, -1, this.props, false, {}, {}, false);
            }
          }
        }
      });
    }
  }

  render() {
    const { baseConfig = {}, textareaConfig = {} } = this.props.config;
    return (
      <div
        ref={ele => {
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props))}
        className={textareaConfig.textareaContent.indexOf('table') >= 0 ? "pipeline-textarea has-table" : "pipeline-textarea"}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px'
        }}
      >
        <div
          className={textareaConfig.textareaContent.indexOf('table') >= 0 ? 'textarea-content has-table' : 'textarea-content'}
          dangerouslySetInnerHTML={{__html: textareaConfig.textareaContent}}
        >
          
        </div>
      </div>
    );
  }
}

PipelineTextarea.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineTextarea };
export default PipelineTextarea;



// WEBPACK FOOTER //
// ./components/pipeline-textarea/index.js